// extracted by mini-css-extract-plugin
export default {"intro":"_8i-SyvWm","wrapper":"FoPuX+Vo","thermometer":"Vyv-wYn7","row":"_0TU1-686","temperature":"objEyGOn","year":"_73tEFvq0"};